import { Card, CardBody, Col, Form } from 'reactstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import { PreFetchHeading } from '../../../../../Utils/Constants'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'
import { countryDataList, preFetchData } from '../../../../../Data/Forms/FormsWidgets/Typeahead/Typeahead'

const PreFetch = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon title={PreFetchHeading} span={preFetchData} />
        <CardBody>
          <div id="the-basics">
            <Form className="theme-form">
              <div>
                <Typeahead options={countryDataList} placeholder="Countries" id="PreFetch"/>
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default PreFetch